module.exports = __webpack_public_path__ + "static/media/Acc-3b.127c8cb8.png";